import withUnderReviewText from './withUnderReviewText'
import Detail from 'components/AccountFileDetailUnderReview'

export default withUnderReviewText(Detail)
